<template>
  <div class="main-form">
     <!-- 加载指示器 -->
    <div v-if="isLoading" class="loading-bar">
      <div class="loading-bar-progress"></div>
    </div>
    <div class="header">
      <h1>
        人物关系
        <h3>{{ pageTitle }}</h3>
      </h1>
      <div class="toolbar">
        <button class="add-btn" @click="toggleView">
          <span v-if="isListView"><i class="fas fa-plus"></i> 新增</span>
          <span v-else><i class="fas fa-list"></i> 列表</span>
        </button>
      </div>
    </div>
    <div class="table-container" v-if="isListView">
      <table class="data-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>关系</th>
            <th @click="sortBy('importance')">
              重要性
              <i :class="getSortIcon('importance')"></i>
            </th>
            <th @click="sortBy('createdAt')">创建时间</th>
            <th @click="sortBy('updatedAt')">
              更新时间
              <i :class="getSortIcon('updatedAt')"></i>
            </th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in filteredAndPaginatedData" :key="row.id">
            <td>{{ row.id }}</td>
            <td>{{ row.relationship }}</td>
            <td>
              <div v-if="!row.importanceEdit">{{ row.importance }}</div>
              <div v-else>
                <input type="number" v-model="row.importance" />
              </div>
              <button v-if="!row.importanceEdit" @click="editCell(row)">
                <i class="fas fa-edit"></i>
              </button>
              <button @click="saveCell(row)" v-else>
                <i class="fas fa-save"></i>
              </button>
            </td>
            <td>{{ row.createdAt }}</td>
            <td>{{ row.updatedAt }}</td>
            <td>
              <button @click="editRow(row.id)">
                <i class="fas fa-edit"></i>
              </button>
              <button @click="deleteRow(row.id)">
                <i class="fas fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination" v-if="isListView">
      <div>
        <label class="showPage" for="pageSize">每页显示:</label>
        <select v-model="pageSize" id="pageSize">
          <option value="10">10条</option>
          <option value="20">20条</option>
          <option value="30">30条</option>
          <option value="50">50条</option>
        </select>
      </div>
      <div>
      <button v-if="!isMobile" @click="prevPage" :disabled="currentPage === 1">
        上一页
      </button>
      <button v-if="isMobile" @click="prevPage" :disabled="currentPage === 1">
        ◀
      </button>
      <div class="jump">
        跳转到&nbsp;<input
          type="number"
          v-model.number="gotoPage"
          min="1"
          :max="totalPages"
          @change="jumpToPage"
        />&nbsp;页
      </div>
      <button
        v-if="!isMobile"
        @click="nextPage"
        :disabled="currentPage >= totalPages"
      >
        下一页
      </button>
      <button
        v-if="isMobile"
        @click="nextPage"
        :disabled="currentPage >= totalPages"
      >
        ▶
      </button>
    </div>
      <div>
        <span class="page-info"
          >第 {{ currentPage }} 页,共 {{ totalPages }} 页</span
        >
      </div>
    </div>

    <div class="detail" v-else>
      <form v-if="isCreating" @submit.prevent="submitForm">
        <br />
        <hr class="myhr" />
        <br />
        <div class="row">
          <div class="control-label">
            <div style="color: red">*&nbsp;&nbsp;</div>
            关系
          </div>
          <div class="box-body">
            <input
              type="text"
              v-model="formData.relationship"
              placeholder="输入关系"
              required
            />
          </div>
        </div>
        <div class="row">
          <div class="control-label">
            <div style="color: red">*&nbsp;&nbsp;</div>
            排序
          </div>
          <div class="box-body">
            <input type="number" v-model="formData.importance" required />
          </div>
        </div>
        <br />
        <hr class="myhr" />
        <button type="submit"><i class="fas fa-save"></i>提交</button>
      </form>

      <div v-else>
        <form @submit.prevent="updateDetails">
          <br />
          <hr class="myhr" />
          <br />
          <div class="row">
            <div class="control-label">ID:</div>
            <div class="box-body">{{ details.id }}</div>
          </div>
          <div class="row">
            <div class="control-label">
              <div v-if="isEditing" style="color: red">*&nbsp;&nbsp;</div>
              关系:
            </div>
            <div class="box-body">
              <div v-if="!isEditing">{{ details.relationship }}</div>
              <div v-else>
                <input type="text" v-model="formData.relationship" required />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="control-label">
              <div v-if="isEditing" style="color: red">*&nbsp;&nbsp;</div>
              排序:
            </div>
            <div class="box-body">
              <div v-if="!isEditing">{{ details.importance }}</div>
              <div v-else>
                <input type="number" v-model="formData.importance" required />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="control-label">创建时间:</div>
            <div class="box-body">{{ details.createdAt }}</div>
          </div>
          <div class="row">
            <div class="control-label">更新时间:</div>
            <div class="box-body">{{ details.updatedAt }}</div>
          </div>
          <br />
          <hr class="myhr" />
          <br />
          <button @click="editDetails" v-if="!isEditing">
            <i class="fas fa-pencil-alt"></i>编辑
          </button>
          <button @click="deleteDetails" v-if="!isEditing">
            <i class="fas fa-trash"></i>删除
          </button>
          <button type="submit" v-if="isEditing">
            <i class="fas fa-check"></i>更新
          </button>
          <button @click="resetForm" v-if="isEditing">
            <i class="fas fa-redo"></i>重置
          </button>
        </form>
      </div>
    </div>
    <div v-if="showBackToTop" class="back-to-top" @click="backToTop">↑</div>
    <CustomAlert v-if="showAlert" :message="alertMessage" :type="alertType" />
    <CustomConfirm
      :isVisible="isConfirmVisible"
      title="确认删除"
      message="您确定要删除这条记录吗？此操作无法撤销。"
      @confirm="confirmDelete"
      @cancel="() => (isConfirmVisible = false)"
    />
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import CustomAlert from "@/components/CustomAlert.vue";
import CustomConfirm from "@/components/CustomConfirm.vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import axios from "@/axios";

const store = useStore();
const router = useRouter();

const tableData = ref([
]);
const isLoading = ref(false);
const searchQuery = ref("");
const pageSize = ref(10);
const currentPage = ref(1);
const sortKey = ref("");
const sortDirection = ref("asc");
const isMobile = ref(window.innerWidth <= 768);
const showBackToTop = ref(false);
const gotoPage = ref(1);
const pageTitle = ref("列表");
const isListView = ref(true);
const isCreating = ref(false);
const isEditing = ref(false);
const formData = ref({
  relationship: "",
  importance: 0,
});
const details = ref({
  id: "",
  relationship: "",
  importance: "",
  createdAt: "",
  updatedAt: "",
});

const selectedRowId = ref(null);
const isConfirmVisible = ref(false);
const showAlert = ref(false);
const alertMessage = ref("");
const alertType = ref("");

const showCustomAlert = (message, type = "info") => {
  alertMessage.value = message;
  alertType.value = type;
  showAlert.value = true;
  setTimeout(() => {
    showAlert.value = false;
  }, 3000);
};

const fetchTableData = async () => {
   isLoading.value = true;
  try {
    const response = await axios.get("/task-relationships");
    if (response.status == 200) {
      if (response.data != null) {
        tableData.value = response.data;
      }else{
         tableData.value = [];
      }
    } else {
      showCustomAlert(response.data.error, "error");
    }
  } catch (error) {
    showCustomAlert(error.response.data.error || "获取数据失败", "error");
    console.error("获取数据失败:", error);
    if (error.response.data.error == "登录过期") {
      localStorage.removeItem("loggedIn");
      store.dispatch("logout");
      router.push("/login");
    }
  }finally {
    isLoading.value = false; // 完成加载
  }
};

onMounted(fetchTableData);

const editCell = (row) => {
  row.importanceEdit = true;
};

const saveCell = async (row) => {
  row.importanceEdit = false;
  var id = row.id;
  try {
    var req = {
      importance: row.importance,
    };
    const response = await axios.put(`/task-relationships-update/${id}`, req);
    if (response.status == 200) {
      showCustomAlert(response.data.message, "success");
      fetchTableData();
    } else {
      showCustomAlert(response.data.error, "error");
    }
  } catch (error) {
    showCustomAlert(error.response.data.error || "更新失败", "error");
    console.error("更新失败:", error);
    if (error.response.data.error == "登录过期") {
      localStorage.removeItem("loggedIn");
      store.dispatch("logout");
      router.push("/login");
    }
  }
};

const filteredData = computed(() => {
  if (!searchQuery.value) {
    return tableData.value;
  }
  return tableData.value.filter(
    (row) =>
      row.relationship.includes(searchQuery.value) ||
      row.id.toString().includes(searchQuery.value)
  );
});

const filteredAndPaginatedData = computed(() => {
  const start = (currentPage.value - 1) * pageSize.value;
  const end = start + pageSize.value;
  return filteredData.value.slice(start, end);
});

const totalPages = computed(() => {
  return Math.ceil(filteredData.value.length / pageSize.value);
});

const toggleView = () => {
  isListView.value = !isListView.value;
  if (isListView.value) {
    pageTitle.value = "列表";
    isCreating.value = false;
    isEditing.value = false;
    fetchTableData();
  } else {
    pageTitle.value = "创建";
    isCreating.value = true;
    resetForm();
  }
};

const submitForm = async () => {
  if(formData.value.importance == 0){
    showCustomAlert("请输入排序",'warning');
    return;
  }
  pageTitle.value = "详细";
  isCreating.value = false;
  var req = {
    relationship: formData.value.relationship,
    importance: formData.value.importance,
  };
  try {
    const response = await axios.post("/task-relationships", req);
    if (response.status == 200) {
      showCustomAlert(response.data.message, "success");
      var data = {
        id: response.data.id,
        relationship: response.data.relationship,
        importance: response.data.importance,
        createdAt: response.data.created_at,
        updatedAt: response.data.created_at,
      };
      tableData.value.push(data);
      details.value = data;
    } else {
      showCustomAlert(response.data.error, "error");
    }
  } catch (error) {
    showCustomAlert(error.response.data.error || "提交失败", "error");
    console.error("提交失败:", error);
    if (error.response.data.error == "登录过期") {
      localStorage.removeItem("loggedIn");
      store.dispatch("logout");
      router.push("/login");
    }
  }
};

const confirmDelete = async () => {
  // 删除逻辑
  try {
    const response = await axios.delete(
      `/task-relationships/${selectedRowId.value}`
    );
    if (response.status === 200) {
      showCustomAlert(response.data.message, "success");
    } else {
      showCustomAlert(response.data.error, "error");
    }
  } catch (error) {
    showCustomAlert(error.response.data.error || "删除失败", "error");
    if (error.response.data.error == "登录过期") {
      localStorage.removeItem("loggedIn");
      store.dispatch("logout");
      router.push("/login");
    }
  } finally {
    isConfirmVisible.value = false;
    selectedRowId.value = null;
    fetchTableData();
    isListView.value = true;
    pageTitle.value = "列表";
    isCreating.value = false;
    isEditing.value = false;
  }
};

const updateDetails = async () => {
  if(formData.value.importance == 0){
    showCustomAlert("请输入排序",'warning');
    return;
  }
  isEditing.value = false;
  try {
    var req = {
      relationship: formData.value.relationship,
      importance: formData.value.importance,
    };
    const response = await axios.put(
      `/task-relationships/${details.value.id}`,
      req
    );
    if (response.status == 200) {
      showCustomAlert(response.data.message, "success");
      isEditing.value = false;
      details.value = {
        ...formData.value,
        updatedAt: new Date().toLocaleString(),
      };
    } else {
      showCustomAlert(response.data.error, "error");
    }
  } catch (error) {
    showCustomAlert(error.response.data.error || "更新失败", "error");
    console.error("更新失败:", error);
    if (error.response.data.error == "登录过期") {
      localStorage.removeItem("loggedIn");
      store.dispatch("logout");
      router.push("/login");
    }
  }
};

const editDetails = () => {
  isEditing.value = true;
  formData.value = { ...details.value };
};

const deleteDetails = () => {
  selectedRowId.value = details.value.id;
  isConfirmVisible.value = true;
};

const resetForm = () => {
  formData.value = {
    relationship: "",
    importance: 0,
  };
};

const editRow = (id) => {
  const row = tableData.value.find((row) => row.id === id);
  if (row) {
    isListView.value = false;
    pageTitle.value = "详细";
    isCreating.value = false;
    isEditing.value = true;
    details.value = { ...row };
    formData.value.relationship = row.relationship;
    formData.value.importance = row.importance;
    formData.value.createdAt = row.createdAt;
    formData.value.id = row.id;
    formData.value.updatedAt = row.updatedAt;
  }
};

const deleteRow = (id) => {
  selectedRowId.value = id;
  isConfirmVisible.value = true;
};

const sortBy = (key) => {
  if (sortKey.value === key) {
    sortDirection.value = sortDirection.value === "asc" ? "desc" : "asc";
  } else {
    sortKey.value = key;
    sortDirection.value = "asc";
  }
  tableData.value.sort((a, b) => {
    let result = 0;
    if (a[key] < b[key]) result = -1;
    if (a[key] > b[key]) result = 1;
    return sortDirection.value === "asc" ? result : -result;
  });
};

const getSortIcon = (key) => {
  if (sortKey.value !== key) {
    return "fas fa-sort";
  }
  return sortDirection.value === "asc"
    ? "fas fa-arrow-up"
    : "fas fa-arrow-down";
};

const prevPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--;
  }
};

const nextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++;
  }
};

const jumpToPage = () => {
  if (gotoPage.value >= 1 && gotoPage.value <= totalPages.value) {
    currentPage.value = gotoPage.value;
  }
};

const handleResize = () => {
  isMobile.value = window.innerWidth <= 768;
};

const handleScroll = () => {
  showBackToTop.value = window.scrollY > 300;
};

const backToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

onMounted(() => {
  window.addEventListener("resize", handleResize);
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
  window.removeEventListener("scroll", handleScroll);
});
</script>

<style scoped>
/* ========== 全局基础 ========== */
.main-form {
  padding: 24px 32px;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  background: linear-gradient(135deg, #f5f7fc 0%, #eef2f8 100%);
  min-height: 100vh;
  color: #1a2634;
}

/* ========== 头部 ========== */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  flex-wrap: wrap;
  gap: 20px;
}

.header h1 {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  background: linear-gradient(135deg, #1f2b38, #2c3e4e);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  letter-spacing: -0.01em;
}

.header h3 {
  margin: 6px 0 0 4px;
  font-size: 0.95rem;
  font-weight: 500;
  color: #5b6e8c;
}

/* 工具栏按钮组 */
.toolbar {
  display: flex;
  gap: 14px;
  align-items: center;
  flex-wrap: wrap;
}

.add-btn {
  background: linear-gradient(105deg, #2c3e50 0%, #1e2a36 100%);
  border: none;
  padding: 10px 24px;
  border-radius: 40px;
  color: white;
  font-weight: 600;
  font-size: 0.9rem;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.add-btn:hover {
  background: linear-gradient(105deg, #1e2a36, #141f28);
  transform: translateY(-1px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

/* ========== 表格容器 ========== */
.table-container {
  background: white;
  border-radius: 28px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.06);
  overflow-x: auto;
  margin-bottom: 28px;
  border: 1px solid rgba(226, 237, 242, 0.6);
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
  min-width: 700px;
}

.data-table th {
  background: #fafcfd;
  color: #2c3e50;
  font-weight: 600;
  padding: 16px 12px;
  border-bottom: 1px solid #e9f0f3;
  font-size: 0.85rem;
  letter-spacing: 0.3px;
}

.data-table td {
  padding: 14px 12px;
  text-align: center;
  border-bottom: 1px solid #eff3f6;
  color: #2c3e50;
}

.data-table tr:hover td {
  background-color: #f8fbfd;
}

/* 表头排序图标 */
.data-table th i {
  margin-left: 6px;
  font-size: 0.8rem;
  color: #8ba0b0;
  cursor: pointer;
}

/* 表格内编辑/保存按钮 */
.data-table td button {
  background: transparent;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 40px;
  margin: 0 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #5a7a9a;
  font-size: 1rem;
}

.data-table td button:hover {
  background: #f0f4f9;
  color: #2c3e50;
  transform: translateY(-2px);
}

.data-table td button:active {
  transform: translateY(1px);
}

/* 表格内输入框（重要性编辑） */
.data-table input {
  width: 80px;
  padding: 6px 8px;
  border: 1px solid #dfe8ef;
  border-radius: 20px;
  text-align: center;
  font-size: 0.85rem;
  outline: none;
  transition: 0.2s;
}

.data-table input:focus {
  border-color: #8ba0b0;
  box-shadow: 0 0 0 2px rgba(99, 125, 145, 0.2);
}

/* ========== 分页组件 ========== */
.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  background: white;
  padding: 14px 20px;
  border-radius: 60px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
  width: fit-content;
  margin: 0 auto;
  border: 1px solid #e9f0f3;
}

.pagination > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pagination button {
  background: white;
  border: 1px solid #dee7ec;
  padding: 8px 18px;
  border-radius: 32px;
  font-weight: 500;
  font-size: 0.85rem;
  color: #2c3e50;
  cursor: pointer;
  transition: 0.2s;
}

.pagination button:hover:not(:disabled) {
  background: #f0f4f9;
  border-color: #b9ccd9;
  transform: translateY(-1px);
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination select, .pagination input {
  border: 1px solid #dee7ec;
  border-radius: 32px;
  padding: 8px 14px;
  background: white;
  font-size: 0.85rem;
  outline: none;
}

.pagination select:focus, .pagination input:focus {
  border-color: #8ba0b0;
  box-shadow: 0 0 0 2px rgba(99, 125, 145, 0.2);
}

.showPage {
  font-size: 0.85rem;
  color: #4a627a;
  margin-right: 6px;
}

.page-info {
  font-size: 0.85rem;
  background: #f2f6f9;
  padding: 6px 14px;
  border-radius: 32px;
  color: #2c3e50;
}

/* ========== 详情表单卡片 ========== */
.detail {
  background: white;
  border-radius: 32px;
  padding: 32px 36px;
  max-width: 880px;
  margin: 20px auto;
  box-shadow: 0 20px 35px -12px rgba(0, 0, 0, 0.1);
  border: 1px solid #eef3f8;
}

.detail .row {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 20px;
  flex-wrap: wrap;
}

.detail .control-label {
  width: 140px;
  font-weight: 600;
  color: #2c3e50;
  font-size: 0.9rem;
  text-align: right;
  display: flex;
  align-items: center;
  gap: 4px;
}

.detail .box-body {
  flex: 1;
  padding: 12px 18px;
  border: 1px solid #dfe8ef;
  border-radius: 48px;
  background: white;
  font-size: 0.9rem;
  transition: 0.2s;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.detail .box-body:focus-within {
  border-color: #8ba0b0;
  box-shadow: 0 0 0 2px rgba(99, 125, 145, 0.2);
}

.detail .box-body input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 0.9rem;
  flex: 1;
  min-width: 0;
}

/* 表单按钮区域统一布局 */
.detail form {
  display: flex;
  flex-direction: column;
}

.detail form > button,
.detail form .form-actions {
  margin-top: 24px;
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
}

/* 按钮统一样式 */
.detail button {
  min-width: 120px;
  padding: 12px 24px;
  border-radius: 40px;
  font-weight: 600;
  font-size: 0.9rem;
  transition: 0.2s;
  cursor: pointer;
  border: none;
}

/* 主按钮（提交/更新） */
.detail button[type="submit"] {
  background: #2c3e50;
  color: white;
  align-items: center;
}

.detail button[type="submit"]:hover {
  background: #1e2a36;
  transform: translateY(-2px);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.1);
}

/* 次按钮（重置/编辑/删除等） */
.detail button:not([type="submit"]) {
  background: #f0f4f9;
  border: 1px solid #dfe8ef;
  color: #4a627a;
}

.detail button:not([type="submit"]):hover {
  background: #e6edf4;
  border-color: #cbdde6;
  transform: translateY(-1px);
}

/* 横线 */
.myhr {
  margin: 24px 0;
  border: 0;
  height: 1px;
  background: linear-gradient(to right, transparent, #dfe8ef, transparent);
}

/* ========== 加载进度条 ========== */
.loading-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: #e2edf2;
  z-index: 2000;
}

.loading-bar-progress {
  height: 100%;
  background: linear-gradient(90deg, #2c3e50, #5d7f9e);
  animation: loading 1.2s infinite ease;
}

@keyframes loading {
  0% { width: 0%; left: 0; }
  50% { width: 70%; left: 15%; }
  100% { width: 100%; left: 0; }
}

/* ========== 返回顶部 ========== */
.back-to-top {
  position: fixed;
  bottom: 32px;
  right: 24px;
  width: 48px;
  height: 48px;
  background: #2c3e50;
  color: white;
  border-radius: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: 0.2s;
  z-index: 1000;
}

.back-to-top:hover {
  transform: translateY(-4px);
  background: #1e2a36;
}

/* ========== 手机端适配 ========== */
@media (max-width: 768px) {
  .main-form {
    padding: 20px 16px;
  }

  .jump {
     font-size: small;
  }
  
  .header h1 {
    font-size: 1.8rem;
  }

  .toolbar {
    width: 100%;
  }

  .pagination {
    flex-direction: column;
    width: 100%;
    border-radius: 40px;
    padding: 12px 18px;
  }

  .detail {
    padding: 24px 20px;
  }

  .detail .row {
    flex-direction: column;
    align-items: flex-start;
  }

  .detail .control-label {
    width: auto;
    text-align: left;
    margin-bottom: 4px;
  }

  .detail .box-body {
    width: 100%;
    padding: 12px 16px;
  }

  .detail .box-body input {
    width: 100%;
  }

  .detail button {
    min-width: 100px;
    padding: 10px 20px;
  }

  .data-table th,
  .data-table td {
    font-size: 13px;
    padding: 10px 6px;
  }

  .add-btn,
  .detail button,
  .pagination button {
    font-size: 13px;
    padding: 5px 10px;
  }

  .page-info,
  .showPage {
    font-size: 13px;
  }

  .data-table input {
    width: 60px;
  }
}
</style>